import React, { Component, Fragment } from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Tooltip } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import { fieldValidation } from "../../../../utils/formValidation"
import { formValues, taskErrorCode } from "../containers/InventoryTaskformData"
import axios from 'axios';
import InfoIcon from '@material-ui/icons/Info';
import { format_Commas, validationMess } from "../../../../utils"
import { addTaskFormApi, deleteAttachment, inventorySectionList } from "../apiServices"
import { globalGetService, globalPutService } from "../../../../utils/globalApiServices"
import GetAppIcon from '@material-ui/icons/GetApp';
import AttachmentIcon from '@material-ui/icons/Attachment';
import LinkIcon from '@material-ui/icons/Link';
import { checkApiStatus } from "../../../../utils"
import SectionCreates from "../../../../shared_elements/components/SectionCreates"
import LinkFiles from "../../../../shared_elements/components/LinkFiles"
import UploadFile from "../../../../shared_elements/components/UploadFile"
import { regexConstants } from "../../../../constants/regEx"
import { assetType, imgStoragePath, specificKey } from "../../../../constants";
import config from "../../../../config";
import { PageLoader } from "../../../../shared_elements";
class InventoryTaskForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: {},
            data: { ...formValues },
            attachments: [],
            btnStatus: "",
            newUploadedAttachments: [],
            open: false,
            deleteAttachmentId: 0,
            showSuccessUpload: false,
            linkFile: false,
            uploadFile: false,
            sectionList: [],
            pageLoader: false,
            submitLoader: false,
        }
        this.addTaskFormApi = addTaskFormApi.bind(this)
        this.inventorySectionList = inventorySectionList.bind(this)
        this.dropDownChange1 = this.dropDownChange1.bind(this)
        this.dropDownChange2 = this.dropDownChange2.bind(this)

    }

    componentDidMount = () => {
        if (this.props.editFormId) {
            this.fillEditData()
        } else {
            this.getRemovalDateData()
        }
        this.inventorySectionList(this.props)
    }
    getRemovalDateData = () => {
        const { match } = this.props.props
        globalGetService(`camo/get_removal_date_data/?asset_id=${match.params?.asset}&asset_type_id=${match?.params?.assetType}`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    const { tsn_basic_details, csn_basic_details } = response.data?.data || {}
                    this.setState((prevState) => ({
                        ...prevState,
                        data: { ...prevState.data, tsn:tsn_basic_details, csn:csn_basic_details, },
                    }))
                }
            })
    }
    handleOpenFile = () => {
        this.setState({ linkFile: true })
    };
    handleCloseFile = () => {
        this.setState({ linkFile: false })
    };
    handleOpenUploadFile = () => {
        this.setState({ uploadFile: true })
    };
    handleUploadCloseFile = () => {
        this.setState({ uploadFile: false })
    };

    onFieldChange = (keyParam, value) => {
        const { data } = this.state

        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [keyParam]: value,
            },
        }))
    }
    dropDownChange1(e, keyParam, value) {
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                installed: e.target.value,
            },
        }))
    }
    dropDownChange2 = (e, keyParam, value) => {
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [keyParam]: value,
            },
        }))
    }
    onRestErrorKey = (keyParam) => {
        this.setState((prevState) => ({
            ...prevState,
            error: {
                ...prevState.error,
                [keyParam]: "",
            },
        }))
    }

    handleSubmit = (e) => {
        e.preventDefault()
        if (this.state.submitLoader) {
            return
        }
        let validationInputs = {}
        const { data } = this.state
        const props = this.props.props
        validationInputs = {
            description: taskErrorCode["description"][fieldValidation({ ...taskErrorCode["description_obj"], fieldval: data.description })]
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === "" })) {
            let payload = Object.assign({}, data)
            payload = {
                ...payload,
                asset_id: props.match.params.asset,
                asset_type_id: props.match.params.assetType,
                quantity: payload?.quantity ? parseInt(payload.quantity) : 0,
                tsn: payload?.tsn ? payload?.tsn : null,
                csn: payload?.csn ? payload?.csn : null,
                tso: payload?.tso ? payload?.tso : null,
                cso: payload?.cso ? payload?.cso : null,
            }
            this.setState({ submitLoader: true })
            addTaskFormApi(payload, props, this.props.addForm).then(async (response) => {
                const uploadId = response.data?.data?.id
                if (uploadId) {
                    await this.uploadFileTest(uploadId, props, false)
                    this.props.getResponseBack()
                }
                this.setState({ submitLoader: false })
                if (uploadId && this.state.btnStatus !== "addAnother") {
                    this.props.closeAddForm()
                } else {
                    return false
                }
            }).catch(() => {
                this.setState({ submitLoader: false })
            })

        } else {
            this.setState({ error: validationInputs })
        }

    }

    fillEditData = () => {
        const updateId = this.props.editFormId
        this.setState({ attachments: this.props.attachments })
        if (updateId === undefined || updateId === null) {
            this.setState({
                data: {},
            })
        } else {
            this.setState({
                data: this.props.editFormData,
            })
        }

    }

    updateData = async (e) => {
        e.preventDefault()
        let validationInputs = {}
        const { data } = this.state
        const props = this.props.props
        validationInputs = {
            description: taskErrorCode["description"][fieldValidation({ ...taskErrorCode["description_obj"], fieldval: data.description })]
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === "" })) {
            delete data.delete_status
            delete data.delete_timestamp
            delete data.deleted_by
            delete data.restore_timestamp
            delete data.restored_by
            delete data.is_restored
            let payload = Object.assign({}, data)
            payload = {
                ...payload,
                asset_id: props.match.params.asset,
                asset_type_id: props.match.params.assetType,
                quantity: payload?.quantity ? parseInt(payload.quantity) : 0,
                tsn: payload?.tsn ? payload?.tsn : null,
                csn: payload?.csn ? payload?.csn : null,
                tso: payload?.tso ? payload?.tso : null,
                cso: payload?.cso ? payload?.cso : null,
            }
            const updateId = this.props.editFormId
            this.setState({
                data: this.props.editFormData,
            })

            if (updateId) {
                await this.uploadFileTest(updateId, props, true)
            }
            await this.props.updateFormData(updateId, payload, props, this.props.addForm, this.props.closeAddForm)
            // this.props.closeAddForm()
        } else {
            this.setState({ error: validationInputs })
        }
    }

    uploadFileTest = async (uploadId, props, isUpdate) => {
        if (this.state.newUploadedAttachments.length > 0) {
            let newAttachmentObj = []
            let formdata = new FormData()
            const module_type_id = 10
            Object.keys(this.state.newUploadedAttachments).map((key, index) => {
                newAttachmentObj.push({
                    file: this.state.newUploadedAttachments[key],
                    file_name: this.state.newUploadedAttachments[key].name,
                    file_type: this.state.newUploadedAttachments[key].type,
                    module_type_id,
                    module_id: uploadId,
                    asset_id: this.props.props.match.params.asset,
                    asset_type_id: this.props.props.match.params.assetType

                })
                formdata.append("[" + key + "]file", this.state.newUploadedAttachments[key])
                formdata.append("[" + key + "]file_type", this.state.newUploadedAttachments[key].type)
                formdata.append("[" + key + "]file_name", this.state.newUploadedAttachments[key].name)
                formdata.append("[" + key + "]module_id", uploadId)
                formdata.append("[" + key + "]module_type_id", module_type_id)
                formdata.append("[" + key + "]asset_id", this.props.props.match.params.asset)
                formdata.append("[" + key + "]asset_type_id", this.props.props.match.params.assetType)
            })
            this.props.fileUploadData(uploadId, formdata, props, true)
            if (this.state.btnStatus === "addAnother") {
                this.resetBothAttachmentArray()
            }
            if (!isUpdate) {
                this.onSubmitFileLink(uploadId)
                this.props.fileUploadData(uploadId, null, props, false)
            }
        } else {
            if (this.state.btnStatus === "addAnother") {
                this.setState((prevState) => ({
                    ...prevState,
                    data: formValues,
                    attachments: [],
                }))
                document.getElementById("asset-form").reset()
                this.getRemovalDateData()
                this.props.fileUploadData(uploadId, null, props, false)
            } else {
                if (!isUpdate) {
                    this.onSubmitFileLink(uploadId)
                    this.props.fileUploadData(uploadId, null, props, false)
                }
            }
        }
    }

    resetBothAttachmentArray = () => {
        this.setState((prevState) => ({
            ...prevState,
            data: formValues,
            attachments: [],
            newUploadedAttachments: [],
        }))
        document.getElementById("asset-form").reset()
        this.getRemovalDateData()
    }

    onUpload = (files) => {
        const chosenFiles = Array.prototype.slice.call(files)
        for (let i = 0; i < chosenFiles.length; i++) {
            if (chosenFiles[i].size > 52428800) {
                this.props.props.enqueueSnackbar(
                    `${chosenFiles[i].name} Maximum file size should be 50MB.`,
                    {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                    }
                )
                delete chosenFiles[i]
                continue
            } else {
                this.handleUploadFiles(chosenFiles)
                this.setState({
                    showSuccessUpload: true,
                })
                setTimeout(() => {
                    if (this.state.attachments) {
                        this.setState({
                            showSuccessUpload: false,
                        })
                    }
                }, 2500)
            }
        }
    }

    handleUploadFiles = (files) => {
        const uploaded = [...this.state.newUploadedAttachments]
        const existingAttachments = [...this.state.attachments]
        files.some((file) => {
            uploaded.push(file)
        })
        files.map((file) => {
            var objc = {
                id: 0,
                module_id: 0,
                module_type_id: 10,
                file_name: file.name,
                file_type: file.type,
                file: "upload file",
                name: file.name,
                asset_id: this.props.props.match.params.asset,
                asset_type_id: this.props.props.match.params.assetType
            }
            existingAttachments.push(objc)
        })
        this.setState({
            newUploadedAttachments: uploaded,
            attachments: existingAttachments,
        })
    }

    handleClickAttachment = (e, id) => {
        this.setState({ open: true })
        this.setState({ deleteAttachmentId: id })
    }

    handleCloseAttachment = (e) => {
        this.setState({ open: false })
        this.setState({ deleteAttachmentId: 0 })
    }
    deleteAttachmentFile = async (id, attachments) => {
        if (id !== undefined && id != 0) {
            const props = this.props.props
            deleteAttachment(id, props)
            var array = [...this.state.attachments]
            array = array.filter((item) => item.id !== id)
            this.setState({ attachments: array, open: false, deleteAttachmentId: 0 })
        } else {
            this.onRemoveCamoFile(attachments)
        }
    }
    removeAttachment = (e, obj) => {
        var array = [...this.state.attachments]
        var newuploadarray = [...this.state.newUploadedAttachments]
        var filteredArray = []
        newuploadarray.map((file) => {
            if (file.name == obj.file_name && file.type == obj.file_type) {
            } else {
                filteredArray.push(file)
            }
        })
        array = array.filter((item) => item !== obj)
        this.setState({
            newUploadedAttachments: filteredArray,
            attachments: array,
        })
    }

    saveAndAddAnother = async (e) => {
        await this.setState({ btnStatus: "addAnother" })
        await this.handleSubmit(e)
    }

    addFormData = async (e) => {
        await this.setState({ btnStatus: "add" })
        this.handleSubmit(e)
    }

    downloadFile = (file) => {
        axios.get(decodeURIComponent(file.path), { timeout: 600000, responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.name);
                document.body.appendChild(link);
                link.click();
            })
    }
    onUnlinkCheckListFile = (checklist, fileId) => {
        const { data } = this.state;
        let payload = {};
        payload.delete = true;
        payload.folder_ids = checklist?.folders?.filter(items => items.type === 'folder').map(file => file.id).filter((id) => id !== fileId).join(',');
        payload.file_ids = checklist?.files?.filter(items => items.type === 'file').map(file => file.id).filter((id) => id !== fileId).join(',');
        globalPutService(`camo/inventory/${this.props.editFormId}/document-checklists/`, payload)
            .then((response) => {
                if (checkApiStatus(response)) {
                    const updatedChecklist = { ...checklist };
                    updatedChecklist.files = updatedChecklist.files.filter((file) => file.id !== fileId);
                    updatedChecklist.folders = updatedChecklist?.folders.filter((file) => file.id !== fileId);
                    this.setState({
                        data: {
                            ...data,
                            checklist: updatedChecklist,
                        },
                    });
                }
            });
    }
    onRemoveFile = (file) => {
        const { data } = this.state;
        this.setState({
            data: {
                ...data,
                checklist: data.checklist.filter(item => item.name !== file.name)
            }
        });
    }
    onRemoveCamoFile = (file) => {
        const { attachments } = this.state;
        this.setState({
            attachments: attachments.filter(item => item.file_name !== file.file_name)
        });
    }

    getResponseBack = (file) => {
        const { data, } = this.state
        this.setState({
            data: {
                ...data,
                checklist: file,
            },
        });

    }
    listResponseBack = (file) => {
        if (this.props.actionType === "add" || "edit") {
            return null
        } else {
            this.props.getResponseBack(file)
        }

    }

    onLinkFile = (file, uuid, type) => {
        const { data } = this.state;
        if (type == "link" || uuid) {
            const folderUUID = [...data.folder_uuid, uuid];
            const updatedChecklist = [...data.checklist, file];

            let uuidData = [];
            let output = [];

            for (const arr of folderUUID) {
                uuidData = uuidData.concat(arr);
            }

            for (const arr of updatedChecklist) {
                output = output.concat(arr);
            }
            this.setState({
                data: {
                    ...data,
                    checklist: output,
                    folder_uuid: uuidData.join("")
                },
            });
        } else {
            this.onUpload(file)
        }
    }

    onSubmitFileLink = (id) => {
        const { data } = this.state;
        if (data?.checklist?.length > 0 && data.checklist.map(item => item.id).filter(item => item)) {
            let payload = {};
            if (data?.checklist.some(item => item.type === 'folder') && data?.checklist.some(item => item.type === 'file')) {
                payload.folder_ids = data?.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
                payload.file_ids = data?.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
            } else if (data?.checklist.some(item => item.type === 'folder')) {
                payload.folder_ids = data?.checklist.filter(item => item.type === 'folder').map(file => file.id).join(',');
            } else {
                payload.file_ids = data?.checklist.filter(item => item.type === 'file').map(file => file.id).join(',');
            }
            globalPutService(`camo/inventory/${id}/document-checklists/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        this.props.getResponseBack()
                    } else {
                        this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                });
        }
        if (data?.folder_uuid?.length > 0 && data.folder_uuid) {
            let formData = new FormData();
            formData.append('folder_uuid', data.folder_uuid);
            for (let i = 0; i < data.checklist.filter(item => item instanceof File).length; i++) {
                formData.append('files[]', data.checklist.filter(item => item instanceof File).length && data.checklist.filter(item => item instanceof File)[i]);
            }
            globalPutService(`camo/inventory/${id}/document-checklists/`, formData)
                .then(response => {
                    if (checkApiStatus(response)) {
                        this.props.getResponseBack()
                    } else {
                        this.props.props.enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                    }
                });
        }
    }

    render() {
        const { data, attachments, error, sectionList, submitLoader } = this.state
        const { assetsDetail } = this.props
        const indexing = assetsDetail?.map((item, index) => item.id).sort((b, a) => b - a)[0] === this.props?.id
        return (
            <Fragment>
                {submitLoader ? <PageLoader /> : null}
                <div id="AmpTaskForm">
                    <DialogTitle className="just-center">
                        {this.props.formTitle}
                        <CloseIcon onClick={() => { this.props.closeAddForm(); this.listResponseBack() }} className="close-icon" />
                    </DialogTitle>
                    <form id="asset-form" onSubmit={this.props.actionType === "add" ? (e) => this.handleSubmit(e) : (e) => this.updateData(e)} >
                        <DialogContent>
                            <Grid spacing={1} container>
                                <Grid item md={3} sm={6} xs={12}>
                                    <SectionCreates
                                        label='Section'
                                        options={sectionList}
                                        getOptionLabel={(option) => option}
                                        paramsKey='section'
                                        optionKey='name'
                                        value={data.section}
                                        onFieldChange={this.dropDownChange2}

                                    />
                                </Grid>
                                <Grid item md={9} sm={6} xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        label="Description"
                                        id="description"
                                        InputLabelProps={{ shrink: true }}
                                        error={error.description ? true : false}
                                        helperText={error.description ? error.description : ""}
                                        value={data.description ? data.description : ""}
                                        inputProps={{ maxLength: 250 }}
                                        onChange={(e, value) => { this.onFieldChange("description", e.target.value); this.onRestErrorKey("description") }}
                                    />
                                </Grid>

                            </Grid>
                            <Grid spacing={1} container>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label="IIN"
                                        name="iin"
                                        id="iin"
                                        InputLabelProps={{ shrink: true }}
                                        value={data.iin ? data.iin : ""}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(e, value) => this.onFieldChange("iin", e.target.value)}
                                    />
                                </Grid>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label="Spec"
                                        id="spec"
                                        InputLabelProps={{ shrink: true }}
                                        value={data.spec ? data.spec : ""}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(e, value) => this.onFieldChange("spec", e.target.value)}
                                    />
                                </Grid>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label="IPC & PPBU FIG. / REF"
                                        id="ipc_ppbu_fig_ref"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ maxLength: 50 }}
                                        value={data.ipc_ppbu_fig_ref ? data.ipc_ppbu_fig_ref : ""}
                                        onChange={(e, value) => this.onFieldChange("ipc_ppbu_fig_ref", e.target.value)}
                                    />
                                </Grid>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label="Quantity"
                                        id="quantity"
                                        InputLabelProps={{ shrink: true }}
                                        value={data.quantity ? data.quantity : ""}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const numericValue = value.replace(/[^\d.]/g, '');
                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                            const isValid = numericValue.replace(".", "").length - dotCount <= 3 && regexConstants.onlyNumeric.test(numericValue);

                                            if (isValid || value === "") {
                                                this.onFieldChange("quantity", numericValue);
                                            }

                                            this.onRestErrorKey("quantity");
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label="Part Number"
                                        id="part_number"
                                        InputLabelProps={{ shrink: true }}
                                        value={data.part_number ? data.part_number : ""}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(e) => this.onFieldChange("part_number", e.target.value)} // change as per validation sheet
                                    />
                                </Grid>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label="Serial Number"
                                        id="serial_number"
                                        InputLabelProps={{ shrink: true }}
                                        value={data.serial_number ? data.serial_number : ""}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(e) => this.onFieldChange("serial_number", e.target.value)} // change as per validation sheet
                                    />
                                </Grid>
                                <Grid item item md={3} sm={6} xs={12} id="ht-dropdown">
                                    <FormControl>
                                        <InputLabel
                                            id="demo-simple-select-label"
                                            className="dropdown-label"
                                        >
                                            Installed
                                        </InputLabel>
                                        <Select
                                            labelId="installed"
                                            id="installed"
                                            variant="outlined"
                                            value={data.installed}
                                            onChange={this.dropDownChange1}
                                        >
                                            <MenuItem value={"Yes"}>YES</MenuItem>
                                            <MenuItem value={"No"}>NO</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label="Condition"
                                        id="condition"
                                        InputLabelProps={{ shrink: true }}
                                        value={data.condition ? data.condition : ""}
                                        inputProps={{ maxLength: 50 }}
                                        onChange={(e) => { this.onFieldChange("condition", e.target.value); this.onRestErrorKey("condition") }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                TSN
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        id="tsn"
                                        disabled={this.props.actionType === "edit" ? !indexing : assetsDetail?.length >= 1}
                                        // value={format_Commas(data?.tsn) || ''}
                                        error={error.tsn ? true : false}
                                        helperText={error.tsn ? error.tsn : ""}
                                        inputProps={{maxLength:regexConstants.alphanumespcespclchar.test(data.tsn) && 10}}
                                        value={regexConstants.alphanumespcespclchar.test(data.tsn) ? data.tsn : format_Commas(data?.tsn.toString().replace(/[^0-9.]/g, '')) }
                                        onChange={(e) => {
                                            const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                            const numericValue = value.replace(/[^\d.]/g, '');
                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                            const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("tsn", e.target.value);
                                        		this.setState({ error: {...error, tsn:e.target.value  === (null || undefined || "")  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('TSN',true)}, })
                                            }else if(isValid || value === ""){
                                                this.onFieldChange("tsn", numericValue);
                                                this.setState({ error: {...error, tsn:regexConstants.numberWithDot.test(numericValue) || e.target.value  === (null || undefined || "") ? "" : e.target.value  === null  ? "" : ""}})
                                                this.onRestErrorKey("tsn");
                                            }
                                         }}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                    />
                                </Grid>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                CSN
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        id="csn"
                                        disabled={this.props.actionType === "edit" ? !indexing : assetsDetail?.length >= 1}
                                        // value={format_Commas(data?.csn) || ''}
                                        error={error.csn ? true : false}
                                        helperText={error.csn ? error.csn : ""}
                                        inputProps={{maxLength:regexConstants.alphanumespcespclchar.test(data.csn) && 9}}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                        value={regexConstants.alphanumespcespclchar.test(data.csn) ? data.csn :format_Commas(data?.csn.toString().replace(/[^0-9.]/g, '')) }
                                        onChange={(e) => {
                                            if(regexConstants.alphanumespcespclchar.test(e.target.value)){
                                                this.onFieldChange("csn", e.target.value);
                                                this.setState({ error: {...error, csn:e.target?.value  === null  || e.target?.value === ""  ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('CSN',false)}, })
                                            }else{
                                                this.setState({ error: {...error, csn:e.target?.value  === null  || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === ""  ? "" : ""}})
                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('csn', e.target.value); this.onRestErrorKey("csn") }}
                                            }
                                    />
                                </Grid>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                TSO
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999.99 </span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        id="tso"
                                        error={error.tso ? true : false}
                                        helperText={error.tso ? error.tso : ""}
                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.tsn) && 10 }}
                                        value={regexConstants.alphanumespcespclchar.test(data.tso) ? data.tso : format_Commas(data?.tso.replace(/[^0-9.]/g, ''))}
                                        onChange={(e) => {
                                            const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                            const numericValue = value.replace(/[^\d.]/g, '');
                                            const dotCount = (numericValue.match(/\./g) || []).length;
                                            const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 7 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("tso", e.target.value);
                                                this.setState({ error: { ...error, tso: e.target.value === (null || undefined || "") ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('TSO', true) }, })

                                            } else if (isValid || value === "") {
                                                this.onFieldChange("tso", numericValue);
                                                this.setState({ error: { ...error, tso: regexConstants.numberWithDot.test(numericValue) || e.target.value === (null || undefined || "") ? "" : e.target.value === null ? "" : "" } })
                                                this.onRestErrorKey("tso");
                                            }

                                        }}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                    />
                                </Grid>
                                <Grid item md={3} sm={6} xs={12}>
                                    <TextField
                                        variant="outlined"
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                CSO
                                                <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 0 to 99999</span>} arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        error={error.cso ? true : false}
                                        helperText={error.cso ? error.cso : ""}
                                        inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data.cso) && 9 }}
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                        id="cso"
                                        value={regexConstants.alphanumespcespclchar.test(data.cso) ? data.cso : format_Commas(data?.cso.toString().replace(/[^0-9.]/g, ''))}
                                        onChange={(e) => {
                                            if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                                this.onFieldChange("cso", e.target.value);
                                                this.setState({ error: { ...error, cso: e.target?.value === null || e.target?.value === "" ? "" : !specificKey.includes(e.target.value.toUpperCase()) && validationMess('CSO', false) }, })
                                            } else {
                                                this.setState({ error: { ...error, cso: e.target?.value === null || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === "" ? "" : "" } })
                                                e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && this.onFieldChange('cso', e.target.value); this.onRestErrorKey("cso")
                                            }
                                        }
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <div className="border-grey"></div>
                            <Grid spacing={1} container>
                                <Grid item md={6} sm={6} xs={12}>
                                    <TextField
                                        label="Remarks"
                                        margin='normal'
                                        variant='outlined'
                                        fullWidth
                                        value={data.remarks}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => this.onFieldChange("remarks", e.target.value)}
                                        rows={3}
                                        multiline
                                        inputProps={{ maxLength: 250 }}
                                    />
                                </Grid>
                                <Grid item md={6} sm={6} xs={12}>
                                    <div className="upload-amp-textbox" style={{ border: "1px solid gray", textAlign: 'center' }}>
                                        <ul className="list-inline spacing-list">
                                            <li className="list-inline-item" onClick={this.handleOpenUploadFile} >
                                                <span className="flex-centered"><AttachmentIcon color='primary' fontSize='small' /> Upload File</span>
                                            </li>
                                            <li className="list-inline-item" onClick={this.handleOpenFile}>
                                                <span className="flex-centered"><LinkIcon color='primary' fontSize='small' />Link file from Records Module</span>
                                            </li>
                                        </ul>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid id="data-container" spacing={1} container>
                                <Grid spacing={1} container>
                                    {this.props.actionType === 'add' ?
                                        <div className='checklist-files'>
                                            <ul className='list-inline'>
                                                {data?.checklist?.map((file) =>
                                                    <li className='list-inline-item'>
                                                        <span className='file-name'>{file.name}</span>
                                                        <span className='file-remove'>
                                                            <a href={decodeURIComponent(file.path)} download={file.name}>  <GetAppIcon color="primary" /></a>
                                                            <CloseIcon onClick={() => this.onRemoveFile(file)} color='secondary' fontSize='small' />
                                                        </span>
                                                    </li>
                                                )}
                                                {attachments.length > 0 && attachments?.map((attachments) =>
                                                    <li className='list-inline-item'>
                                                        <span className='file-name'>{attachments.file_name}</span>
                                                        <span className='file-remove'>
                                                            <a href={decodeURIComponent(attachments.file)} download={attachments.file_name}>  <GetAppIcon color="primary" /></a>
                                                            <CloseIcon onClick={() => this.onRemoveCamoFile(attachments)} color='secondary' fontSize='small' />
                                                        </span>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                        :
                                        <div className='checklist-files'>
                                            <ul className='list-inline'>
                                                {data?.checklist?.files?.map((file) =>
                                                    <li className='list-inline-item'>
                                                        <span className='file-name'>{file.name}</span>
                                                        <span className='file-remove'>
                                                            <a href={decodeURIComponent(file.path)} download={file.name}>  <GetAppIcon color="primary" /></a>
                                                            <CloseIcon onClick={() => this.onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
                                                        </span>
                                                    </li>
                                                )}
                                                {(data.checklist?.folders?.length > 0) &&
                                                    data.checklist?.folders.map((file) => {
                                                        return (
                                                            <li className='list-inline-item' key={file.id}>
                                                                <Tooltip title={`Records Data Room :- ${file?.location}`} arrow>
                                                                    <a href={`${config.domain.records}${assetType[this.props.props?.match.params.assetType]}/${file?.asset_slug}/data-room/technical/${file?.uuid}`} target="_new"><img style={{ width: '15px', float: 'right', marginRight: '-18px', marginTop: '7px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Reacords Data Room" /></a>
                                                                </Tooltip>
                                                                <span className='file-name'>{file.name}</span>
                                                                <span className='file-remove'>
                                                                    <CloseIcon onClick={() => this.onUnlinkCheckListFile(data.checklist, file.id)} color='secondary' fontSize='small' />
                                                                </span>
                                                            </li>
                                                        );
                                                    })}
                                                {attachments?.map((attachments) =>
                                                    <li className='list-inline-item'>
                                                        <span className='file-name'>{attachments.file_name}</span>
                                                        <span className='file-remove'>
                                                            <a href={decodeURIComponent(attachments.file)} download={attachments.file_name}>  <GetAppIcon color="primary" /></a>
                                                            <CloseIcon onClick={() => this.deleteAttachmentFile(attachments.id, attachments)} color='secondary' fontSize='small' />
                                                        </span>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>}
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions className="actions-btn">
                            <Button type="button" className="btn btn-primary" disabled={submitLoader} onClick={this.props.actionType === "add" ? (e) => this.addFormData(e) : (e) => this.updateData(e)} >
                                {this.props.actionType === "add" ? "Add" : "Update"}
                            </Button>
                            {this.props.actionType === "add" ? (
                                <Button disabled={submitLoader} onClick={(e) => this.saveAndAddAnother(e)} type="button" className="btn btn-primary" > Save & Add Another </Button>
                            ) : (
                                ""
                            )}
                            <Button type="button" className="btn btn-primary" onClick={() => { this.props.closeAddForm(); this.listResponseBack() }} > Close </Button>
                        </DialogActions>
                        <Dialog open={this.state.linkFile} onClose={this.handleCloseFile} id="htDialog">
                            <LinkFiles
                                handleClose={() => this.handleCloseFile()}
                                uuid={this.props?.uuid?.uuid}
                                editFormId={this.props.editFormId}
                                getResponseBack={(file) => this.getResponseBack(file)}
                                listResponseBack={(file) => this.listResponseBack(file)}
                                actionType={this.props.actionType}
                                onLinkFile={(file, any, type) => this.onLinkFile(file, any, type)}
                                modType="inventory"
                                last_used_folder_uuid={this.props.last_used_folder_uuid_link_document}
                                uploadFileInfo={data}
                                attachments={attachments}
                                type="link"
                            />
                        </Dialog>
                        <Dialog open={this.state.uploadFile} onClose={this.handleUploadCloseFile} id="htDialog">
                            <UploadFile
                                handleClose={() => this.handleUploadCloseFile()}
                                uuid={this.props?.uuid?.uuid}
                                editFormId={this.props.editFormId}
                                getResponseBack={(file) => this.getResponseBack(file)}
                                listResponseBack={(file) => this.listResponseBack(file)}
                                actionType={this.props.actionType}
                                onLinkFile={(file, uuid) => this.onLinkFile(file, uuid)}
                                modType="inventory"
                                uploadFileInfo={data}
                                last_used_folder_uuid={this.props.last_used_folder_uuid}
                                onUpload={(file) => this.onUpload(file)}
                                type="upload"
                                checkbox_last_used_folder_uuid={this.props.checkbox_last_used_folder_uuid}
                                checkbox_last_used_folder_name={this.props.checkbox_last_used_folder_name}
                            />
                        </Dialog>
                    </form>
                </div>
            </Fragment>
        )
    }
}
export default InventoryTaskForm